module.exports = __webpack_public_path__ + "static/media/marriage-4.2c51c6be.jpg";